module.exports = __webpack_public_path__ + "static/media/spade.c9111145.png";